import React, { useState } from 'react';
import VentoryWhiteSvg from '../../../assets/img/Ventory-WhiteNoBack.svg';
import SignInCredentialsView from './views/SignInCredentialsView';
import ForgotPasswordView from './views/ForgotPasswordView';
import SignInCodeView from './views/SignInCodeView';

export enum SignInScreenView {
  credentials = 'credentials',
  code = 'code',
  forgotPassword = 'forgotPassword',
}

export function SignInScreen() {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [view, setView] = useState<SignInScreenView>(SignInScreenView.credentials);

  return (
    <div className='flex h-dvh flex-col items-center justify-center bg-ventory-blue-900'>
      <div className='w-[350px]'>
        <div className='mb-4 flex items-center justify-center'>
          <img src={VentoryWhiteSvg} className='w-[250px]' />
        </div>
        <div className='flex flex-col gap-2 bg-white px-6 py-4'>
          {view === SignInScreenView.credentials && (
            <SignInCredentialsView
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              setView={setView}
            />
          )}
          {view === SignInScreenView.code && <SignInCodeView email={email} password={password} setView={setView} />}
          {view === SignInScreenView.forgotPassword && <ForgotPasswordView setView={setView} />}
        </div>
      </div>
    </div>
  );
}
